import { get_tamima } from "http/components/Requests";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { set_TamimaData } from "../../Redux/slices/dataSlice";
import MainLayout from "Screens/components/MainLayout";
import MainPara from "Screens/components/MainPara";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { HandleLoading } from "Utils/Helpers/ApiServices";

export default function TamimaIndex() {
  const dispatch = useDispatch();
  const { tamima } = useSelector((state) => ({
    tamima: state.data.tamima,
  }));

  useEffect(() => {
    getTamimaData();
  }, []);

  const getTamimaData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_tamima();
    if (CheckApiStatus(response)) dispatch(set_TamimaData(response.data));
    dispatch(HandleLoading(false));
  };

  return (
    <MainLayout
      pageContent={
        <>
          {tamima &&
            tamima.infos.map((items, index) => {
              return (
                <MainPara
                  key={`tamima-data-${index + 1}`}
                  title={items.title}
                  text={items.body}
                />
              );
            })}
        </>
      }
      imageSrc={tamima && tamima.image}
      imageAlt={"HomePageImage"}
    />
  );
}
